import { atom } from "recoil";

export const tipsAtom = atom({
  key: "tipsAtom",
  default: {
    isVisible: false,
  },
});
